// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WhyHostFormBlock2-commonHeaderAdmin-wFY2t {
	position: fixed !important;
}

.WhyHostFormBlock2-adminLayout-xLlWs {
	padding-top: 64px !important;
}

.WhyHostFormBlock2-box-C8EuT h2 {
	font-size: 21px;
	font-weight: 600;
}

.WhyHostFormBlock2-exportLink-V6cX6 {
	margin-bottom: -29px;
}

.WhyHostFormBlock2-blockCenter-P5lV7 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.WhyHostFormBlock2-panelHeader-_owHs {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.WhyHostFormBlock2-currencyselect-TYWc5 {
	width: 100%;
	margin-right: 0px;
}

.WhyHostFormBlock2-panelHeader-_owHs {
	overflow: hidden;
	position: relative;
}

.WhyHostFormBlock2-mar0-lVc5M {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock2-blockCenter-P5lV7 {
		padding: 0px;
	}

	.WhyHostFormBlock2-panelHeader-_owHs {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.WhyHostFormBlock2-sideAdminPageWrapper-uE8N_ {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.WhyHostFormBlock2-panelHeader-_owHs {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.WhyHostFormBlock2-table-Jyoiw {
	display: table;
}

.WhyHostFormBlock2-tableRow-XCmo0 {
	display: table-row;
}

.WhyHostFormBlock2-tableCell-bTOMZ {
	display: table-cell;
	float: none;
}

.WhyHostFormBlock2-formGroup-WDS9K {
	margin-bottom: 6px;
}

.WhyHostFormBlock2-select-TH30k {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.WhyHostFormBlock2-noMargin-lRlxt {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.WhyHostFormBlock2-exportLink-V6cX6 {
	padding-top: 10px;
	padding-right: 10px;
}

.WhyHostFormBlock2-labelTextNew-eZiCW {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock2-displayInline-UJ33L {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.WhyHostFormBlock2-btnUPdate-VaEC6 {
	display: inline-block;
}

.WhyHostFormBlock2-btnModalDelete-UPOB9 {
	display: inline-block;
	margin-left: 15px;
}

.WhyHostFormBlock2-radioBtn-VqSHy {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.WhyHostFormBlock2-backgroundImg-jSXC5 {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock2-btnUPdate-VaEC6 {
		display: block;
		margin-bottom: 12px;
	}

	.WhyHostFormBlock2-btnModalDelete-UPOB9 {
		display: block;
		margin-left: 0px;
	}

	.WhyHostFormBlock2-btnWidth-KdVm3 {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.WhyHostFormBlock2-bannerImageBg-WJ1z4 {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.WhyHostFormBlock2-bannerDelete-fkIG9 {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.WhyHostFormBlock2-modalRoot-zfTVW {
	padding: 32px;
}

.WhyHostFormBlock2-modalBorderBottom-yqYTc {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.WhyHostFormBlock2-logInModalBody-TuXt7 {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.WhyHostFormBlock2-exportSection-AgTV5 {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.WhyHostFormBlock2-exportSectionGridSub-XQ7kj {
	grid-template-columns: 50% 49% !important;
}

.WhyHostFormBlock2-exportText-DD7cP {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.WhyHostFormBlock2-exportLinkImg-sECVT {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.WhyHostFormBlock2-vtrMiddle-bYl7i {
	vertical-align: middle;
}

.WhyHostFormBlock2-exportImg-A6rvB {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.WhyHostFormBlock2-profileViewlabel-jpfmJ {
	display: inline-block;
	width: 38%
}

.WhyHostFormBlock2-profileViewMainContent-d6PFo {
	display: inline-block;
	width: 62%;
}

.WhyHostFormBlock2-profileViewMain-q6NQ7 {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.WhyHostFormBlock2-profileViewInner-eqyD9 {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock2-profileImageSection-yaEoz {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.WhyHostFormBlock2-lastviewInner-NzVQ2 {
	padding: 10px;
}

.WhyHostFormBlock2-whyHostHoriLine-preOh {
	margin: 30px 0;
}

.WhyHostFormBlock2-tableGrid-wtuxr {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.WhyHostFormBlock2-headingContent-g_lzb {
	font-size: 18px;
	font-weight: 500;
}

.WhyHostFormBlock2-refundTextColor-fZ6_d {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.WhyHostFormBlock2-dividerLine-Wq4J9 {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.WhyHostFormBlock2-smallContent-lGN1n {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.WhyHostFormBlock2-sideAdminPageWrapper-uE8N_ {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.WhyHostFormBlock2-sideAdminPageWrapper-uE8N_ {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.WhyHostFormBlock2-exportSection-AgTV5 {
		grid-template-columns: 100%;
	}

	.WhyHostFormBlock2-exportSectionGridSub-XQ7kj {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.WhyHostFormBlock2-profileViewlabel-jpfmJ {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.WhyHostFormBlock2-profileViewMainContent-d6PFo {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.WhyHostFormBlock2-ChangeToUpperCase-V5rVK {
	text-transform: uppercase
}

.WhyHostFormBlock2-noBorder-Pnsb3 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.WhyHostFormBlock2-siteAdminHeading-Tt0dB {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock2-siteAdminSubHeading-nBxAf {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.WhyHostFormBlock2-adminFormDivider-klVIO {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.WhyHostFormBlock2-errorMessage-mNT9x {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.WhyHostFormBlock2-panelHeader-_owHs {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.WhyHostFormBlock2-formGroup-WDS9K {
  margin-bottom: 6px;
}

.WhyHostFormBlock2-select-TH30k {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.WhyHostFormBlock2-labelText-L2rvY {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.WhyHostFormBlock2-space1-fCEYk {
	margin-bottom: 6px !important;
}

.WhyHostFormBlock2-space2-wyTEl {
	margin-bottom: 12px !important;
}

.WhyHostFormBlock2-space3-gnpBF {
	margin-bottom: 18px !important;
}

.WhyHostFormBlock2-space4-Hs_YS {
	margin-bottom: 24px !important;
}

.WhyHostFormBlock2-space5-viPL8 {
	margin-bottom: 30px !important;
}

.WhyHostFormBlock2-space6-cRLBD {
	margin-bottom: 36px !important;
}

.WhyHostFormBlock2-space7-RhNhu {
	margin-bottom: 42px !important;
}

.WhyHostFormBlock2-spaceTop8-Z74Y9 {
	margin-bottom: 48px !important;
}

.WhyHostFormBlock2-spaceTop1-rAK_l {
	margin-top: 6px !important;
}

.WhyHostFormBlock2-spaceTop2-ApGir {
	margin-top: 12px !important;
}

.WhyHostFormBlock2-spaceTop3-_e7HM {
	margin-top: 18px !important;
}

.WhyHostFormBlock2-spaceTop4-KdvcD {
	margin-top: 24px !important;
}

.WhyHostFormBlock2-spaceTop5-FOQ9M {
	margin-top: 30px !important;
}

.WhyHostFormBlock2-spaceTop6-kLzHw {
	margin-top: 36px !important;
}

.WhyHostFormBlock2-spaceTop7-BLpgd {
	margin-top: 42px !important;
}

.WhyHostFormBlock2-spaceTop8-Z74Y9 {
	margin-top: 48px !important;
}

.WhyHostFormBlock2-noMargin-lRlxt {
	margin: 0px !important;
}

.WhyHostFormBlock2-padding1-O7mIJ {
	padding-bottom: 6px !important;
}

.WhyHostFormBlock2-padding2-P6fLf {
	padding-bottom: 12px !important;
}

.WhyHostFormBlock2-padding3-XPaue {
	padding-bottom: 18px !important;
}

.WhyHostFormBlock2-padding4-m5NJc {
	padding-bottom: 24px !important;
}

.WhyHostFormBlock2-padding5-FbEUp {
	padding-bottom: 30px !important;
}

.WhyHostFormBlock2-padding6-FP_R7 {
	padding-bottom: 36px !important;
}

.WhyHostFormBlock2-padding7-Gvgyf {
	padding-bottom: 42px !important;
}

.WhyHostFormBlock2-paddingTop1-ISYGs {
	padding-top: 6px !important;
}

.WhyHostFormBlock2-paddingTop2-Za9SM {
	padding-top: 12px !important;
}

.WhyHostFormBlock2-paddingTop3-PdjPS {
	padding-top: 18px !important;
}

.WhyHostFormBlock2-paddingTop4-Y7smt {
	padding-top: 24px !important;
}

.WhyHostFormBlock2-paddingTop5-aXxi_ {
	padding-top: 30px !important;
}

.WhyHostFormBlock2-paddingTop6-c4b89 {
	padding-top: 36px !important;
}

.WhyHostFormBlock2-paddingTop7-mUX0P {
	padding-top: 42px !important;
}

.WhyHostFormBlock2-noPadding-H0gRE {
	padding: 0px !important;
}

.WhyHostFormBlock2-textBold-zJop6 {
	font-weight: 500 !important;
}

.WhyHostFormBlock2-textBolder-UemBg {
	font-weight: 700 !important;
}

.WhyHostFormBlock2-textNormal-Yr9Vd {
	font-weight: normal !important;
}

.WhyHostFormBlock2-spaceBottom20-u54GS {
	margin-bottom: 20px;
}

.WhyHostFormBlock2-spaceBottom10-nm4Zk {
	margin-bottom: 10px;
}

.WhyHostFormBlock2-marginNone-m0_nW {
	margin: 0;
}

.WhyHostFormBlock2-spaceBottom15-xcOdx {
	margin-bottom: 15px;
}

.WhyHostFormBlock2-marginTopNone-LlHb_ {
	margin-top: 0;
}

.WhyHostFormBlock2-spaceTop11-Gkjel {
	margin-top: 11px;
}

.WhyHostFormBlock2-spaceTop21-JwU3o {
	margin-top: 21px;
}

.WhyHostFormBlock2-spaceTop20-aVqp5 {
	margin-top: 20px;
}

.WhyHostFormBlock2-spaceTop10-MInE3 {
	margin-top: 10px;
}

/*New Design Text Colors */

.WhyHostFormBlock2-textDarkBlue-_jieE {
	color: rgb(20, 39, 94) !important;
}

.WhyHostFormBlock2-textLightBlue-Z7g1v {
	color: rgb(57, 87, 106) !important;
}

.WhyHostFormBlock2-textLightSandleGreen-ZiRyf {
	color: rgb(76, 86, 41) !important;
}

.WhyHostFormBlock2-textLightBrown-PVQP9 {
	color: rgb(115, 79, 33) !important;
}

.WhyHostFormBlock2-textMediumMaroon-d5Zfw {
	color: rgb(87, 37, 51) !important;
}

.WhyHostFormBlock2-textBrown-JxZGG {
	color: rgb(160, 47, 24) !important;
}

.WhyHostFormBlock2-textMaroon-nOh0m {
	color: rgb(155, 49, 67) !important;
}

.WhyHostFormBlock2-textDarkBrown-cXceX {
	color: rgb(83, 18, 16) !important;
}

.WhyHostFormBlock2-textMediumBrown-YMFOT {
	color: rgb(142, 28, 10) !important;
}

.WhyHostFormBlock2-textSkyBlue-rZCzn {
	color: rgb(37, 117, 141) !important;
}

.WhyHostFormBlock2-textGray-mnDiC {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `WhyHostFormBlock2-commonHeaderAdmin-wFY2t`,
	"adminLayout": `WhyHostFormBlock2-adminLayout-xLlWs`,
	"box": `WhyHostFormBlock2-box-C8EuT`,
	"exportLink": `WhyHostFormBlock2-exportLink-V6cX6`,
	"blockCenter": `WhyHostFormBlock2-blockCenter-P5lV7`,
	"panelHeader": `WhyHostFormBlock2-panelHeader-_owHs`,
	"currencyselect": `WhyHostFormBlock2-currencyselect-TYWc5`,
	"mar0": `WhyHostFormBlock2-mar0-lVc5M`,
	"sideAdminPageWrapper": `WhyHostFormBlock2-sideAdminPageWrapper-uE8N_`,
	"table": `WhyHostFormBlock2-table-Jyoiw`,
	"tableRow": `WhyHostFormBlock2-tableRow-XCmo0`,
	"tableCell": `WhyHostFormBlock2-tableCell-bTOMZ`,
	"formGroup": `WhyHostFormBlock2-formGroup-WDS9K`,
	"select": `WhyHostFormBlock2-select-TH30k`,
	"noMargin": `WhyHostFormBlock2-noMargin-lRlxt`,
	"labelTextNew": `WhyHostFormBlock2-labelTextNew-eZiCW`,
	"displayInline": `WhyHostFormBlock2-displayInline-UJ33L`,
	"btnUPdate": `WhyHostFormBlock2-btnUPdate-VaEC6`,
	"btnModalDelete": `WhyHostFormBlock2-btnModalDelete-UPOB9`,
	"radioBtn": `WhyHostFormBlock2-radioBtn-VqSHy`,
	"backgroundImg": `WhyHostFormBlock2-backgroundImg-jSXC5`,
	"btnWidth": `WhyHostFormBlock2-btnWidth-KdVm3`,
	"bannerImageBg": `WhyHostFormBlock2-bannerImageBg-WJ1z4`,
	"bannerDelete": `WhyHostFormBlock2-bannerDelete-fkIG9`,
	"modalRoot": `WhyHostFormBlock2-modalRoot-zfTVW`,
	"modalBorderBottom": `WhyHostFormBlock2-modalBorderBottom-yqYTc`,
	"logInModalBody": `WhyHostFormBlock2-logInModalBody-TuXt7`,
	"exportSection": `WhyHostFormBlock2-exportSection-AgTV5`,
	"exportSectionGridSub": `WhyHostFormBlock2-exportSectionGridSub-XQ7kj`,
	"exportText": `WhyHostFormBlock2-exportText-DD7cP`,
	"exportLinkImg": `WhyHostFormBlock2-exportLinkImg-sECVT`,
	"vtrMiddle": `WhyHostFormBlock2-vtrMiddle-bYl7i`,
	"exportImg": `WhyHostFormBlock2-exportImg-A6rvB`,
	"profileViewlabel": `WhyHostFormBlock2-profileViewlabel-jpfmJ`,
	"profileViewMainContent": `WhyHostFormBlock2-profileViewMainContent-d6PFo`,
	"profileViewMain": `WhyHostFormBlock2-profileViewMain-q6NQ7`,
	"profileViewInner": `WhyHostFormBlock2-profileViewInner-eqyD9`,
	"profileImageSection": `WhyHostFormBlock2-profileImageSection-yaEoz`,
	"lastviewInner": `WhyHostFormBlock2-lastviewInner-NzVQ2`,
	"whyHostHoriLine": `WhyHostFormBlock2-whyHostHoriLine-preOh`,
	"tableGrid": `WhyHostFormBlock2-tableGrid-wtuxr`,
	"headingContent": `WhyHostFormBlock2-headingContent-g_lzb`,
	"refundTextColor": `WhyHostFormBlock2-refundTextColor-fZ6_d`,
	"dividerLine": `WhyHostFormBlock2-dividerLine-Wq4J9`,
	"smallContent": `WhyHostFormBlock2-smallContent-lGN1n`,
	"ChangeToUpperCase": `WhyHostFormBlock2-ChangeToUpperCase-V5rVK`,
	"noBorder": `WhyHostFormBlock2-noBorder-Pnsb3`,
	"siteAdminHeading": `WhyHostFormBlock2-siteAdminHeading-Tt0dB`,
	"siteAdminSubHeading": `WhyHostFormBlock2-siteAdminSubHeading-nBxAf`,
	"adminFormDivider": `WhyHostFormBlock2-adminFormDivider-klVIO`,
	"errorMessage": `WhyHostFormBlock2-errorMessage-mNT9x`,
	"labelText": `WhyHostFormBlock2-labelText-L2rvY`,
	"space1": `WhyHostFormBlock2-space1-fCEYk`,
	"space2": `WhyHostFormBlock2-space2-wyTEl`,
	"space3": `WhyHostFormBlock2-space3-gnpBF`,
	"space4": `WhyHostFormBlock2-space4-Hs_YS`,
	"space5": `WhyHostFormBlock2-space5-viPL8`,
	"space6": `WhyHostFormBlock2-space6-cRLBD`,
	"space7": `WhyHostFormBlock2-space7-RhNhu`,
	"spaceTop8": `WhyHostFormBlock2-spaceTop8-Z74Y9`,
	"spaceTop1": `WhyHostFormBlock2-spaceTop1-rAK_l`,
	"spaceTop2": `WhyHostFormBlock2-spaceTop2-ApGir`,
	"spaceTop3": `WhyHostFormBlock2-spaceTop3-_e7HM`,
	"spaceTop4": `WhyHostFormBlock2-spaceTop4-KdvcD`,
	"spaceTop5": `WhyHostFormBlock2-spaceTop5-FOQ9M`,
	"spaceTop6": `WhyHostFormBlock2-spaceTop6-kLzHw`,
	"spaceTop7": `WhyHostFormBlock2-spaceTop7-BLpgd`,
	"padding1": `WhyHostFormBlock2-padding1-O7mIJ`,
	"padding2": `WhyHostFormBlock2-padding2-P6fLf`,
	"padding3": `WhyHostFormBlock2-padding3-XPaue`,
	"padding4": `WhyHostFormBlock2-padding4-m5NJc`,
	"padding5": `WhyHostFormBlock2-padding5-FbEUp`,
	"padding6": `WhyHostFormBlock2-padding6-FP_R7`,
	"padding7": `WhyHostFormBlock2-padding7-Gvgyf`,
	"paddingTop1": `WhyHostFormBlock2-paddingTop1-ISYGs`,
	"paddingTop2": `WhyHostFormBlock2-paddingTop2-Za9SM`,
	"paddingTop3": `WhyHostFormBlock2-paddingTop3-PdjPS`,
	"paddingTop4": `WhyHostFormBlock2-paddingTop4-Y7smt`,
	"paddingTop5": `WhyHostFormBlock2-paddingTop5-aXxi_`,
	"paddingTop6": `WhyHostFormBlock2-paddingTop6-c4b89`,
	"paddingTop7": `WhyHostFormBlock2-paddingTop7-mUX0P`,
	"noPadding": `WhyHostFormBlock2-noPadding-H0gRE`,
	"textBold": `WhyHostFormBlock2-textBold-zJop6`,
	"textBolder": `WhyHostFormBlock2-textBolder-UemBg`,
	"textNormal": `WhyHostFormBlock2-textNormal-Yr9Vd`,
	"spaceBottom20": `WhyHostFormBlock2-spaceBottom20-u54GS`,
	"spaceBottom10": `WhyHostFormBlock2-spaceBottom10-nm4Zk`,
	"marginNone": `WhyHostFormBlock2-marginNone-m0_nW`,
	"spaceBottom15": `WhyHostFormBlock2-spaceBottom15-xcOdx`,
	"marginTopNone": `WhyHostFormBlock2-marginTopNone-LlHb_`,
	"spaceTop11": `WhyHostFormBlock2-spaceTop11-Gkjel`,
	"spaceTop21": `WhyHostFormBlock2-spaceTop21-JwU3o`,
	"spaceTop20": `WhyHostFormBlock2-spaceTop20-aVqp5`,
	"spaceTop10": `WhyHostFormBlock2-spaceTop10-MInE3`,
	"textDarkBlue": `WhyHostFormBlock2-textDarkBlue-_jieE`,
	"textLightBlue": `WhyHostFormBlock2-textLightBlue-Z7g1v`,
	"textLightSandleGreen": `WhyHostFormBlock2-textLightSandleGreen-ZiRyf`,
	"textLightBrown": `WhyHostFormBlock2-textLightBrown-PVQP9`,
	"textMediumMaroon": `WhyHostFormBlock2-textMediumMaroon-d5Zfw`,
	"textBrown": `WhyHostFormBlock2-textBrown-JxZGG`,
	"textMaroon": `WhyHostFormBlock2-textMaroon-nOh0m`,
	"textDarkBrown": `WhyHostFormBlock2-textDarkBrown-cXceX`,
	"textMediumBrown": `WhyHostFormBlock2-textMediumBrown-YMFOT`,
	"textSkyBlue": `WhyHostFormBlock2-textSkyBlue-rZCzn`,
	"textGray": `WhyHostFormBlock2-textGray-mnDiC`
};
module.exports = ___CSS_LOADER_EXPORT___;
